import { render } from "./currentFiles.vue?vue&type=template&id=3eed106a&lang=pug"
import script from "./currentFiles.vue?vue&type=script&lang=js"
export * from "./currentFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/currentFiles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3eed106a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3eed106a', __exports__)) {
    api.reload('3eed106a', __exports__)
  }
  
  module.hot.accept("./currentFiles.vue?vue&type=template&id=3eed106a&lang=pug", () => {
    api.rerender('3eed106a', render)
  })

}


export default __exports__